exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thanks[data-v-547f950e]{padding:60px 0}.thanks h4[data-v-547f950e]{line-height:3.2rem}.thanks p[data-v-547f950e]{font-size:1.6rem;line-height:2.6rem}.thanks .m-t-30[data-v-547f950e]{margin-top:30px}", ""]);

// exports
